<div class="section-wrapper" id="history">
  <div class="container">
    <!-- <div class="about surge">
      <div class="logo">
        <img loading="lazy" class="circle-logo" src="{{ baseUrl }}surge.svg" alt="surge" />
      </div>
      <div class="content">
        <div class="title surge-title">
          <span class="text-wrapper">Surge</span>
        </div>
        <div class="description">
          {{ 'COMPANY.SURGE.SHORT_HISTORY' | translate }}
        </div>
        <div class="subdescription">
          {{ 'COMPANY.SURGE.DESCRIPTION' | translate }}
        </div>
      </div>
    </div> -->
    <div class="about weave">
      <div class="logo">
        <img loading="lazy" class="circle-logo" src="{{ baseUrl }}weave.svg" alt="weave" />
      </div>
      <div class="content" id="about_weave_content">
        <h2 class="title weave-title">
          <span class="text-wrapper">{{ 'COMPANY.WEAVE.COMPANY_HISTORY' | translate }}</span>
        </h2>
        <!-- <div class="description">
          {{ 'COMPANY.WEAVE.SHORT_HISTORY' | translate }}
        </div>
        <div class="subdescription">
          {{ 'COMPANY.WEAVE.DESCRIPTION' | translate }}  
        </div> -->
        <p class="subdescription" innerHTML="{{ 'COMPANY.WEAVE.HISTORY' | translate }}"></p>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-12 col-md-6">
        <div class="vision" id="vision_mission">
          <div class="title vm-title">
            <span class="text-wrapper">{{ 'COMPANY.VISION.TITLE' | translate }}</span>
          </div>
          <div class="subdescription">
            {{ 'COMPANY.VISION.DESCRIPTION' | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="mission">
          <div class="title vm-title">
            <span class="text-wrapper">{{ 'COMPANY.MISSION.TITLE' | translate }}</span>
          </div>
          <div class="subdescription">
            {{ 'COMPANY.MISSION.DESCRIPTION' | translate }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
